import { useDevCycleClient } from '@devcycle/react-client-sdk';
import { useEffect } from 'react';
import { useAppSelector } from '../../store/app';
import { buildFeatureFlagUser } from './FeatureFlagUser';

/*
 * This renderless component handles updating the DevCycle user with custom attributes
 * that allow us to target users in DevCycle by the current account/org and project _in the
 * context of the UI_.
 */

const FeatureFlagSync = () => {
    const devCycleClient = useDevCycleClient();

    const createUserId = useAppSelector((state) => state.global.user?.id);
    const createUserEmail = useAppSelector((state) => state.global.user?.email);
    const currentOrganizationId = useAppSelector((state) => state.org.organization?.organizationId);
    const currentProjectOrganizationId = useAppSelector((state) => state.studio.project?.organizationId);
    const currentProjectId = useAppSelector((state) => state.studio.project?.id);

    useEffect(() => {
        if (!devCycleClient || !createUserId) return;

        const devCycleUser = buildFeatureFlagUser({
            createUserId,
            createUserEmail,
            currentOrganizationId: currentProjectOrganizationId || currentOrganizationId,
            currentProjectId
        });

        devCycleClient.identifyUser(devCycleUser);
    }, [currentOrganizationId, currentProjectId, createUserId, createUserEmail, currentProjectOrganizationId, devCycleClient]);

    return null;
};

export default FeatureFlagSync;
